module.exports = __webpack_public_path__ + "static/systems-1e1a8ccda6263cddc80e62dfa2e1cc19.jpg";